export default "__VITE_ASSET__D45PuBOv__"